/**
 * The letters an entity shows without a picture: the first letters of its first
 * two words ("Jane Doe" → "JD"), else the first two letters of its only word
 * ("as" → "AS", as the workspace icons in the sidebar). Empty for a blank name.
 */
export function entityInitials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  const letters =
    words.length > 1
      ? words.slice(0, 2).map(word => Array.from(word)[0])
      : Array.from(words[0] ?? '').slice(0, 2);
  return letters.join('').toUpperCase();
}
